/**
 * IAM-lite client-side matcher (mirror of App\IAM\PolicyEvaluator).
 *
 * Each statement is `{ action, resource }` where both strings may use `*` and
 * `?` wildcards (fnmatch semantics). A permission check passes when AT LEAST
 * ONE statement's (action, resource) matches the requested pair.
 *
 * The server is still the authority: this is only used to hide/show UI and
 * to drive router guards. API calls remain authoritatively gated by `iam:`
 * middleware on the Laravel side.
 */

function fnmatchToRegex(pattern) {
  let re = '';
  for (let i = 0; i < pattern.length; i++) {
    const c = pattern[i];
    if (c === '*') re += '.*';
    else if (c === '?') re += '.';
    else re += c.replace(/[.+^${}()|[\]\\]/g, '\\$&');
  }
  return new RegExp('^' + re + '$', 'i');
}

const cache = new Map();
function compile(pattern) {
  if (!cache.has(pattern)) cache.set(pattern, fnmatchToRegex(pattern));
  return cache.get(pattern);
}

function match(pattern, value) {
  return compile(pattern).test(value);
}

/**
 * @param {Array<{action: string, resource: string}>} statements
 * @param {string} action e.g. 'authoring:CreateQuestion'
 * @param {string} [resource='*:*:*'] e.g. 'authoring:question:42'
 */
export function can(statements, action, resource = '*:*:*') {
  if (!Array.isArray(statements) || !action) return false;
  for (let i = 0; i < statements.length; i++) {
    const s = statements[i];
    if (s && match(s.action, action) && match(s.resource, resource)) return true;
  }
  return false;
}

export function cannot(statements, action, resource) {
  return !can(statements, action, resource);
}
